import { Fragment } from 'react';
import {
    FETCH_STATE,
    LoaderWithText,
    RefreshWithErrorText,
} from '../../../common/PatientOverviewUtils';

export const LabVitalEmptyCard: React.FC<{ fetchState?: FETCH_STATE; onRefresh?: () => void }> = ({
    fetchState,
    onRefresh,
}) => {
    return (
        <Fragment>
            <div className="sticky z-10 flex justify-between top-0 flex items-center px-16 py-6 space-x-8 border-b border-neutral-8 bg-white">
                <div className="flex items-center">
                    <div className="flex justify-center items-center w-24 h-24 rounded-4 bg-darwin-accent-bright-yellow-800">
                        <svg
                            className="w-12 h-12 fill-white"
                            viewBox="0 0 14 13"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M12.7656 4.48438L9.01562 0.734375C8.875 0.59375 8.6875 0.5 8.5 0.5C8.28906 0.5 8.10156 0.59375 7.96094 0.734375C7.65625 1.01562 7.65625 1.50781 7.96094 1.78906L8.125 1.95312L1.75 8.30469C0.859375 9.21875 0.695312 10.6953 1.53906 11.6797C2.03125 12.2188 2.6875 12.5 3.36719 12.5C4 12.5 4.60938 12.2891 5.07812 11.7969L11.5469 5.375L11.7109 5.53906C11.8516 5.67969 12.0391 5.75 12.25 5.75C12.4375 5.75 12.625 5.67969 12.7656 5.53906C13.0703 5.25781 13.0703 4.76562 12.7656 4.48438ZM8.26562 6.5H5.6875L9.17969 3.00781L10.4688 4.32031L8.26562 6.5Z"></path>
                        </svg>
                    </div>
                    <p className="font-700 mx-8">Lab Results</p>
                </div>
            </div>
            <div className="pb-26 flex-1 grid place-content-center text-center">
                <div className="w-160 h-155 overflow-hidden m-auto">
                    <img src="/images/Lab-Vitals.png" alt="medical records" />
                </div>
                <p className="font-700 mt-20 mb-18 h-24">
                    {fetchState === FETCH_STATE.FETCHING ? (
                        <LoaderWithText text="Fetching lab results" />
                    ) : fetchState === FETCH_STATE.ERROR ? (
                        <RefreshWithErrorText
                            text="Error in Fetching lab results"
                            onRefresh={onRefresh}
                        />
                    ) : (
                        'No more typing lab reports!'
                    )}
                </p>
                <p className="text-darwin-neutral-600 mx-15 max-w-304">
                    Did you know Eka can automatically scan and read all lab reports? No more
                    typing!
                </p>
            </div>
        </Fragment>
    );
};
